import * as DialogPrimitive from '@radix-ui/react-dialog';
import type { ComponentProps } from 'react';

import { cn } from '@/design-system/lib/cn';

/**
 * Painel lateral à direita (até 560px; tela cheia no celular), sobre Radix Dialog:
 * foco preso e Esc fecham como um diálogo. Entra deslizando 28px em 200ms.
 */
export const Sheet = DialogPrimitive.Root;
export const SheetTitle = DialogPrimitive.Title;
export const SheetDescription = DialogPrimitive.Description;
export const SheetClose = DialogPrimitive.Close;

export function SheetContent({
  className,
  children,
  ...props
}: ComponentProps<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-[60] bg-overlay/35 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
      <DialogPrimitive.Content
        data-slot="sheet-content"
        aria-describedby={undefined}
        className={cn(
          'fixed top-0 right-0 bottom-0 z-[61] flex w-[min(560px,100vw)] flex-col bg-white shadow-sheet outline-none',
          'data-[state=open]:animate-slide-in',
          className
        )}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
